import { render, staticRenderFns } from "./MobileBottomMenuComponent.vue?vue&type=template&id=9498d2f0"
import script from "./MobileBottomMenuComponent.vue?vue&type=script&lang=js"
export * from "./MobileBottomMenuComponent.vue?vue&type=script&lang=js"
import style0 from "./MobileBottomMenuComponent.vue?vue&type=style&index=0&id=9498d2f0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports